/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Dialog, AppBar, Toolbar, IconButton, Typography } from "@mui/material";
import Slide from "@mui/material/Slide";
import { IconX } from "@tabler/icons";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import PolygonGeofenceMap from "src/components/mapFencing/PolygonGeofenceMap";
import GeofencingService from "src/service/geofencing";
import { useParams } from "react-router";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FullscreenDialog = ({ id }) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // State to store geofence data and loading state
  const [geofenceData, setGeofenceData] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Add loading state

  const getGeofenceData = (data) => {
    setGeofenceData(data);
  };

  const [startingPlace, setStartingPlace] = useState({
    name: "",
    latitude: "",
    longitude: "",
  });

  const [startingPlaceMarker, setStartingPlaceMarker] = useState({
    position: { lat: 23.876536, lng: 85.876453 },
    address: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const geofencingData = await GeofencingService.getGeofencingList({
          id: id,
        });

        setStartingPlace({
          geo_fence_name: geofencingData.data[0].geo_fence_name,
        });

        setGeofenceData(geofencingData.data[0].coordinates);
        setIsLoading(false); // Mark data as loaded
      } catch (error) {
        console.error("Error fetching geofencing data:", error);
        setIsLoading(false); // Even on error, set loading to false
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {/* <Button variant="contained" color="error" fullWidth>
        Open Fullscreen Dialog
      </Button> */}
      <FmdGoodIcon
        style={{
          color: "purple",
          fontSize: "22px",
          cursor: "pointer",
          marginLeft: "10px",
        }}
        onClick={handleClickOpen}
      />
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <IconX width={24} height={24} />
            </IconButton>
            <Typography ml={2} flex={1} variant="h6" component="div">
              Map View
            </Typography>
          </Toolbar>
        </AppBar>

        <PolygonGeofenceMap
          center={startingPlaceMarker.position}
          markerPosition={startingPlaceMarker.position}
          SendGeofenceData={geofenceData}
          geofenceData={getGeofenceData}
        />
      </Dialog>
    </>
  );
};

export default FullscreenDialog;
